<template>
  <AdminLayout>
    <Head title="Edit Supplier" />

    <div class="headline flex flex-row justify-between mx-4 sm:mx-12">
      <h2 class="text-2xl font-semibold pb-5 pt-5 text-blue-600">Edit Space</h2>

      <div class="relative inline-flex shadow-sm rounded-md self-start mt-2">
        <button
          @click.prevent="submit()"
          :disabled="form.processing"
          type="button"
          class="inline-flex items-center px-4 py-3 mr-3 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-100 bg-blue-600 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
        >
          Save Changes
        </button>
        <button
          @click.prevent="deleteSpace()"
          :disabled="form.processing"
          type="button"
          class="inline-flex items-center px-4 py-3 mr-3 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-100 bg-red-600 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-600"
        >
          Delete Space
        </button>
      </div>
    </div>

    <div
      v-if="page.props.flash.success"
      class="alert alert-success"
    >
      <p class="alert-text">
        {{ $page.props.flash.success }}
      </p>
    </div>
    <div
      v-if="page.props.flash.error"
      class="alert alert-error"
    >
      <p class="alert-text">
        {{ page.props.flash.error }}
      </p>
    </div>

    <div class="form bg-gray-100 flex-1 py-10 px-4 sm:px-12">
      <form
        method="POST"
        @submit.prevent="submit()"
      >
        <div class="grid grid-cols-12 gap-6">
          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="name"> Name </label>
            <input
              type="text"
              v-model="form.name"
              name="name"
              id="name"
              autocomplete="name"
            />
            <p
              v-if="form.errors.name"
              class="input-error"
            >
              {{ form.errors.name }}
            </p>
          </div>
          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="location"> Location </label>
            <input
              type="text"
              :value="space.location.name"
              name="location"
              id="location"
              readonly
              disabled
            />
          </div>
          <div class="input-group-checkbox col-span-12 sm:col-span-6 lg:col-span-4">
            <div class="input-checkbox-container">
              <input
                v-model="form.is_quarantine"
                id="is_quarantine"
                name="is_quarantine"
                type="checkbox"
              />
            </div>
            <div class="input-label-container">
              <label for="is_quarantine"> Quarantine Room </label>
            </div>
            <p
              v-if="form.errors.is_quarantine"
              class="input-error"
            >
              {{ form.errors.is_quarantine }}
            </p>
          </div>
          <div class="input-group-checkbox col-span-12 sm:col-span-6 lg:col-span-4">
            <div class="input-checkbox-container">
              <input
                v-model="form.is_disabled"
                id="is_disabled"
                name="is_disabled"
                type="checkbox"
              />
            </div>
            <div class="input-label-container">
              <label for="is_disabled"> Disabled </label>
            </div>
            <p
              v-if="form.errors.is_disabled"
              class="input-error"
            >
              {{ form.errors.is_disabled }}
            </p>
          </div>
        </div>
      </form>
    </div>
  </AdminLayout>
</template>

<script setup>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head, useForm, usePage } from '@inertiajs/vue3'
import Label from '@/Components/Auth/Label.vue'
import { useConfirmDialog } from '@/Composables/confirm-dialog'
import { settle } from '@/utils/promises'

const props = defineProps({
  space: Object,
  errors: Object
})

const page = usePage()

const form = useForm({
  name: '',
  is_quarantine: '',
  is_disabled: !!props.space.disabled_at,
  ...(props.space || {})
})

const submit = () => {
  form.put(route('company.spaces.update', props.space.id))
}

const deleteSpace = async () => {
  const { show } = useConfirmDialog()
  const [error, data] = await settle(
    show({
      type: 'danger',
      confirmText: 'Delete',
      body: "Are you sure you want to delete this space? This can't be undone."
    })
  )

  if (!error) {
    useForm({}).delete(route('company.spaces.destroy', props.space.id))
  }
}
</script>
